import { Badge } from "@/components/ui/badge"
import { Card, CardContent } from "@/components/ui/card"
import { ChevronRight } from "lucide-react"
import { Link } from "react-router-dom"
import { useGetActivitiesMetrics } from "../../queries/use-get-activities-metrics"
import { Skeleton } from "@/components/ui/skeleton"
import { useGetObjetivesMetrics } from "../../queries/use-get-objetives-metrics"
import { PRODUCT_TOUR_STEPS } from "@/modules/product-tour/constants/steps"
import { useGetRealHoursOfStudy } from "../../queries/use-get-real-hours-of-study"

export default function StudyMetrics() {
  const activitiesMetrics = useGetActivitiesMetrics()
  const objectivesMetrics = useGetObjetivesMetrics()
  const realHoursOfStudy = useGetRealHoursOfStudy()

  return (
    <section className="mb-4 mt-8 flex flex-col gap-4 px-6">
      <section className="flex items-center justify-between">
        <h1 className="text-lg font-bold">Mis métricas</h1>
        <Link
          to="/my-situation"
          className="font-sm inline-flex items-center gap-2 self-end font-semibold"
          id={PRODUCT_TOUR_STEPS.STUDY_GO_TO_MY_SITUATION}
        >
          <span className="text-muted-foreground">Ir a Mi situación</span>
          <ChevronRight className="size-5" />
        </Link>
      </section>
      <Card className="border-none py-6 shadow-sm">
        <CardContent className="grid grid-cols-3">
          <MetricCard
            title="Horas estudiadas"
            value={`⏳ ${realHoursOfStudy.formattedDuration}`}
            comparison={`${realHoursOfStudy.percentage.toFixed(2)}%`}
            isPending={realHoursOfStudy.isPending}
          />
          <MetricCard
            title="Objetivos cumplidos"
            value={`✅ ${objectivesMetrics.currentApprovalCount}`}
            comparison={`${objectivesMetrics.percentage.toFixed(2)}%`}
            isPending={objectivesMetrics.isPending}
          />
          <MetricCard
            title="Actividades realizadas"
            value={`🎓 ${activitiesMetrics.approvedActivities}`}
            comparison={`${activitiesMetrics.percentage.toFixed(2)}%`}
            isPending={activitiesMetrics.isPending}
          />
        </CardContent>
      </Card>
    </section>
  )
}

function MetricCard({
  title,
  value,
  comparison,
  isPending,
}: {
  title: string
  value: string
  comparison: string
  isPending: boolean
}) {
  const percentage = parseFloat(comparison)

  const formatDiff = () => {
    if (percentage === 0) return "0% sem.pasada"
    return `${percentage > 0 ? "+" : ""} ${percentage}% sem.pasada`
  }
  const variant = percentage === 0 ? "warning" : percentage > 0 ? "default" : "destructive"

  return (
    <div className="flex flex-col gap-4">
      <h2 className="text-sm font-semibold text-muted-foreground">{title}</h2>
      {isPending ? (
        <Skeleton className="h-8 w-24" />
      ) : (
        <span className="inline-flex items-center text-2xl font-bold text-foreground">{value}</span>
      )}
      {isPending ? (
        <Skeleton className="h-5 w-24" />
      ) : (
        <Badge variant={variant} className="w-fit">
          {formatDiff()}
        </Badge>
      )}
    </div>
  )
}
